import React from 'react';
import { Link } from 'react-router-dom';

const ProfileHeaderActions = ({ userType, t }) => {
    const userTypeId = userType ? userType.Id : null;
    const canAccessControl = userTypeId === 1 || (userTypeId !== 5 && userTypeId !== 6);

    return (
        <div className="profile-header-actions-wrapper">
            {canAccessControl && (
                <Link
                    to="/User/Control"
                    className="profile-action-btn btn-action-control"
                    title={t('Pages.UserControl.title')}
                >
                    <i className="fad fa-game-board-alt"></i>
                    <span className="profile-action-text">{t('Pages.UserControl.title')}</span>
                </Link>
            )}

            <Link
                to="/Profile/Edit"
                className="profile-action-btn btn-action-edit"
                title={t('edit')}
            >
                <i className="fal fa-user-edit"></i>
                <span className="profile-action-text">{t('edit')}</span>
            </Link>

            <Link
                to="/Profile/ChangePassword"
                className="profile-action-btn btn-action-password"
                title={t('ChangePassword')}
            >
                <i className="fal fa-key"></i>
                <span className="profile-action-text">{t('ChangePassword')}</span>
            </Link>
        </div>
    );
};

export default ProfileHeaderActions;
